import { render, staticRenderFns } from "./modifyPasw.vue?vue&type=template&id=0beab858&scoped=true"
import script from "./modifyPasw.vue?vue&type=script&lang=js"
export * from "./modifyPasw.vue?vue&type=script&lang=js"
import style0 from "./modifyPasw.vue?vue&type=style&index=0&id=0beab858&prod&lang=less&scoped=true"
import style1 from "./modifyPasw.vue?vue&type=style&index=1&id=0beab858&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beab858",
  null
  
)

export default component.exports